/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** Unique tabs using H6 as an anchor **/
$($('.product-single__content-text').find('h6').get().reverse()).each(function (i) {

  var tabName = $(this).text();
  tabContent = '';

  //check if h6 has text inside
  if ($(this).text() != '') {

    //hide h6
    $(this).hide();

    //combine content between H6 elements
    $(this).nextUntil('h6').each(function () {
      tabContent = tabContent + this.outerHTML;

      //hide content
      $(this).hide();
    });

    //generate tab HTML
    $('.js-accordion').prepend('<div id="acc-unique-' + [i] + '" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
    $('.js-accordion').prepend('<a href="#acc-unique-' + [i] + '" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');

  } else {

    //hide empty H6
    $(this).hide();
  }
});

/** restrictions for Bold Custom options fields **/


const customizationSelectors = {
  uppercase: '[data-uppercase]',
  limitedChars: '[data-chars]',
  productWrapper: '[data-section-type="product"]',
}

const restrictedCharacters = {
  embroidered: '[^a-zA-Z0-9!@#$%&()-./? ]',
  embossed: '[^a-zA-Z0-9!@#$&()-/+:.,\'* ]',
  engraved: '[^a-zA-Z0-9~!@#$%^&*()-_=+\/?<>,.\'“ ]'
}

let UPPERCASE_PRODUCT;
let LIMITED_CHAR_PRODUCT;
let RESTRICTED_CHARS;


/*
  Force capitalization of text fields in products that require it
 */
const capitalizeCharacters = function (field) {
  field.value = field.value.toUpperCase();
}

/*
  Replace restricted characters with empty string
 */
const enforceLimitedChars = function (field) {
  const restricted = new RegExp(restrictedCharacters[RESTRICTED_CHARS], 'g');
  if (field.value.match(restricted)) {
    field.value = field.value.replace(restricted, '');
  }
}


$(document).ready(function () {
  UPPERCASE_PRODUCT = document.querySelector(customizationSelectors.uppercase);
  LIMITED_CHAR_PRODUCT = document.querySelector(customizationSelectors.limitedChars);

  if (LIMITED_CHAR_PRODUCT) {
    RESTRICTED_CHARS = LIMITED_CHAR_PRODUCT.getAttribute('data-chars');
  }
});

$(window).on('load', function () {
  const productWrapper = document.querySelector(customizationSelectors.productWrapper);
  const textFields = productWrapper.querySelectorAll('[type=text]');

  if (textFields.length > 0) {
    textFields.forEach(function (field) {
      field.onkeyup = function () {

        // If it's an uppercase product, capitalize character on key up
        if (UPPERCASE_PRODUCT) {
          capitalizeCharacters(this);
        }

        if (LIMITED_CHAR_PRODUCT) {
          enforceLimitedChars(this);
        }

      }
      field.oninput = function () {

        // If it's an uppercase product, capitalize character on key up
        if (UPPERCASE_PRODUCT) {
          capitalizeCharacters(this);
        }

        if (LIMITED_CHAR_PRODUCT) {
          enforceLimitedChars(this);
        }

      }
    });
  }
});